// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Logo__Wrapper_2dgs_"};